import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatTime, formatDate } from '@utils/helper';
import { STATE } from '../preOrder.constants';


class LogInfo extends PureComponent {
  renderContent = item => (
    <div key={item.id}>
      <span className="time">[{formatTime(item.createdAt)}]</span>
      {` `}
      <span className="user">
        {STATE[item.state]}
      </span>
      {` : `}
      <span className="note">M{item.sizeM} L{item.sizeL} XL{item.sizeXL} XXL{item.sizeXXL}</span>
    </div>
  )
  renderItem = (item) => {
    const itemDate = formatDate(item.createdAt * 1000);
    if (itemDate !== this.lastDate) {
      this.lastDate = itemDate;
      return (
        <Fragment key={`date-${item.id}`}>
          <div className="logDate">{itemDate}</div>
          {this.renderContent(item)}
        </Fragment>
      )
    }
    return this.renderContent(item);
  }
  render() {
    const { logs } = this.props;
    if (!logs) return null;
    const dataSource = [...logs];
    dataSource.sort((a, b) => b.createdAt - a.createdAt)
    this.lastDate = '';
    if (dataSource.length < 2) return '';
    return (
      <div className="logArea">
        {dataSource.map(this.renderItem)}
      </div>
    );
  }
}

LogInfo.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.any)
};

LogInfo.defaultProps = {
  logs: []
}

export default LogInfo;
